import React from 'react';
import { RunHistory } from './RunHistory';
import { AllAutomations } from './AllAutomations';
import { SidebarLayout } from '../../SettingsPage/components/SidebarLayout';

type TProps = {
  projectId: number;
};

export const FlexAutomationPage = (props: TProps) => {
  const { projectId } = props;

  const sections = [
    {
      id: 'all-automations',
      label: 'All Automations',
      component: <AllAutomations projectId={projectId} />,
    },
    {
      id: 'run-history',
      label: 'Run History',
      component: <RunHistory projectId={projectId} />,
    },
  ];

  return (
    <SidebarLayout
      sections={sections}
      activeSectionId="all-automations"
      onlyShowActiveSection
      mainContentClassName="mx-[0px] w-full p-0 min-w-0"
      mainContentWrapperClassName="p-0"
    />
  );
};
